module.exports = __webpack_public_path__ + "static/media/close.2a6d3a80.svg";